import React from 'react';

export default function StepWallet({ form, handleChange, next, prev }) {
  const isValid = /^0x[a-fA-F0-9]{40}$/.test(form.walletEth);

  const inputStyle = {
    width: '100%', padding: '14px 16px',
    background: '#FFF9EE',
    border: `3px solid ${!form.walletEth || isValid ? '#3D1F0A' : '#B33000'}`,
    borderRadius: '12px',
    color: '#3D1F0A', fontSize: '13px',
    fontFamily: "'Nunito', sans-serif", fontWeight: '700',
    marginBottom: '8px', outline: 'none', boxSizing: 'border-box',
    boxShadow: 'inset 0 2px 5px rgba(61,31,10,0.08)',
    letterSpacing: '0.3px',
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '26px', letterSpacing: '1.5px', color: '#3D1F0A', textAlign: 'center', marginBottom: '4px' }}>
        ENTER WALLET ADDRESS
      </h2>
      <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '13px', color: '#6B4A1A', textAlign: 'center', marginBottom: '20px' }}>
        Your ETH wallet address for the whitelist
      </p>

      {/* ETH icon badge */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: '8px', marginBottom: '14px',
      }}>
        <div style={{
          padding: '6px 16px', background: 'rgba(200,116,0,0.1)',
          border: '2px solid rgba(61,31,10,0.2)', borderRadius: '20px',
          fontFamily: "'Bangers', cursive", fontSize: '13px', letterSpacing: '2px', color: '#C87400',
        }}>
          ⬡ ETHEREUM NETWORK
        </div>
      </div>

      <input
        className="wl-input"
        name="walletEth"
        placeholder="0x..."
        value={form.walletEth}
        onChange={handleChange}
        style={inputStyle}
      />
      {form.walletEth && !isValid && (
        <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '12px', color: '#B33000', fontWeight: '800', marginBottom: '10px' }}>
          ⚠ Must be a valid ETH address (0x + 40 hex characters)
        </p>
      )}

      <div style={{
        background: 'rgba(61,31,10,0.06)', border: '2px dashed rgba(61,31,10,0.2)',
        borderRadius: '10px', padding: '8px 12px', marginTop: '8px', marginBottom: '16px',
      }}>
        <p style={{ margin: 0, fontSize: '10px', color: '#6B4A1A', fontFamily: "'Nunito', sans-serif", lineHeight: '1.5' }}>
          🔒 We will <strong>never</strong> ask for your seed phrase or private key.
        </p>
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button className="wl-btn-back" onClick={prev} style={{
          flex: 1, padding: '13px',
          background: '#FFF9EE', border: '2px solid #3D1F0A', borderRadius: '10px',
          color: '#3D1F0A', fontFamily: "'Bangers', cursive", fontSize: '15px', letterSpacing: '1px',
          cursor: 'pointer', boxShadow: '0 4px 0 #7A4A00', transition: 'all 0.1s ease',
        }}>← BACK</button>
        <button className="wl-btn-primary" onClick={next} disabled={!isValid} style={{
          flex: 2, padding: '13px',
          background: isValid ? 'linear-gradient(160deg, #C87400, #A85E00)' : 'rgba(61,31,10,0.15)',
          border: '3px solid #3D1F0A', borderRadius: '10px',
          color: isValid ? '#F5EDD6' : '#8B6914',
          fontFamily: "'Bangers', cursive", fontSize: '17px', letterSpacing: '2px',
          cursor: isValid ? 'pointer' : 'not-allowed',
          transform: isValid ? 'skewX(-4deg)' : 'none',
          boxShadow: isValid ? '0 5px 0 #7A4A00' : 'none',
          opacity: isValid ? 1 : 0.55, transition: 'all 0.12s ease',
        }}>
          <span style={{ display: 'inline-block', transform: isValid ? 'skewX(4deg)' : 'none' }}>
            {isValid ? 'NEXT →' : 'INVALID ADDRESS'}
          </span>
        </button>
      </div>
    </div>
  );
}
